function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.87 28.87",
    id: "snapchat",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 28.87,
    height: 28.87,
    fill: "#fffc00",
    rx: 6.48,
    ry: 6.48,
    style: {
      fill: "#fffc00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M22.83 18.68v-.07a2.11 2.11 0 0 0-.55-.14A5 5 0 0 1 20 16.83a3.86 3.86 0 0 1-.75-1.37.75.75 0 0 1 0-.55 1.27 1.27 0 0 1 .82-.48 3.75 3.75 0 0 0 1-.55c.07-.07.07-.14.14-.21v-.07a.21.21 0 0 0 0-.27.56.56 0 0 0-.34-.34.66.66 0 0 0-.62-.07 2.11 2.11 0 0 1-.55.14h-.07a1 1 0 0 1-.62 0v-.14a7 7 0 0 1 .07-1.16 18.56 18.56 0 0 0-.07-1.91 4.3 4.3 0 0 0-1.78-2.6 4.65 4.65 0 0 0-2.13-.75 2.56 2.56 0 0 0-.75-.07 4.6 4.6 0 0 0-2.94 1A5.4 5.4 0 0 0 10 9.24v.07a5 5 0 0 0-.21 2.26 11 11 0 0 1 0 1.5 1.4 1.4 0 0 1-.75 0H9a2.11 2.11 0 0 1-.55-.14.53.53 0 0 0-.55.14h-.05c-.07.07-.27.21-.27.41v.07a.58.58 0 0 0 .21.34c.07.07.14.07.21.14a3.48 3.48 0 0 0 1.16.48c.21.14.48.27.48.48a1.09 1.09 0 0 1-.21.89 5.62 5.62 0 0 1-1.71 2.05 5.59 5.59 0 0 1-1.3.62h-.07a.6.6 0 0 0-.41.27h-.07c0 .14 0 .34.07.41s.14.14.21.14a4.35 4.35 0 0 0 1.23.41c.27.07.55.14.75.21a.53.53 0 0 0 .07.21c.07.21.14.48.21.75 0 .07.07.07.14.14a.4.4 0 0 0 .26-.09h.07a5.65 5.65 0 0 1 1.85-.07 11.3 11.3 0 0 1 1.78 1 2.64 2.64 0 0 0 1.44.55h1.23a3.43 3.43 0 0 0 .89-.34h.07A12.48 12.48 0 0 1 17.9 21h.1a1.91 1.91 0 0 1 .68-.07 5.94 5.94 0 0 1 1.57.07h.07a.15.15 0 0 0 .14-.14.07.07 0 0 0 .07-.07c0-.07.07-.07 0-.07h.07a1.58 1.58 0 0 1 .27-.75.52.52 0 0 1 .34-.14 6.47 6.47 0 0 0 1.23-.34 1.72 1.72 0 0 0 .55-.34c.01-.15.01-.41-.16-.47z",
    style: {
      fill: "#fefefe",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchat);
export default __webpack_public_path__ + "static/media/snapchat.1093028f73dcfa4165fb0e2fff749b23.svg";
export { ForwardRef as ReactComponent };